<template>
  <div class="lz-field">
    <label class="lz-field-label">Days Requested</label>
    <b-form-input
      type="number"
      class="form-control"
      placeholder="No of days requested"
      min="0.5"
      max="30"
      step="1"
      readonly
      disabled
      :value="daysRequested"
      v-model="totalDaysRequested"
      @change="daysRequestedChanged"></b-form-input>
  </div>
</template>

<script>
const { differenceInBusinessDays } = require('date-fns')

export default {
  name: 'DaysRequestedSelector',
  data() {
    return {
      totalDaysRequested: 0
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    dates() {
      return this.FormData.dates
    },
    daysRequested() {
      return this.FormData.totalDays
    },
    totalBankHolidaysInDates() {
      return this.FormData.totalBankHolidaysInDates
    },
    selectedHolidayType() {
      return this.FormData.holidayType
    }
  },
  mounted() {
    this.totalDaysRequested = this.daysRequested || 1
  },
  methods: {
    daysRequestedChanged(val) {
      this.$store.commit('modifyFormData', {
        key: 'totalDays',
        value: parseFloat(val)
      })
    },
    datesChanged() {
      this.$store.commit('modifyFormData', {
        key: 'totalDays',
        value: this.calcDaysRequested()
      })
      this.totalDaysRequested = this.daysRequested
    },
    calcDaysRequested() {
      if (!this.dates) {
        return 0
      }
      let diff = ['HALFDAY', 'HALFPERSONAL'].includes(this.selectedHolidayType)
        ? 0.5
        : differenceInBusinessDays(
            new Date(this.dates[1] || this.dates[0]),
            new Date(this.dates[0])
          ) + 1
      return diff - this.totalBankHolidaysInDates < 0
        ? 0
        : diff - this.totalBankHolidaysInDates
    }
  },
  watch: {
    dates: {
      handler: 'datesChanged',
      immediate: true
    }
  }
}
</script>
